import { defineMessage } from 'services/localization';

export const messages = {
    errorText: defineMessage('failed_to_add_a_passkey'),
    alreadyAddedError: defineMessage('this_passkey_is_already_added_to_your_account'),
};
